import { IconButton, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DragHandle from "../common/DragHandle";
import { columnTypeToIcon } from "../helpers/columnUtils";

const EditColumn = ({ field, isActiveEdit, onClick }) => {
  const IconComponent = columnTypeToIcon[field?.type];
  return (
    <ListItem
      secondaryAction={
        !isActiveEdit && (
          <IconButton edge="end" aria-label="edit" onClick={onClick}>
            <EditOutlinedIcon />
          </IconButton>
        )
      }
    >
      <ListItemIcon style={{ cursor: 'grab' }} >
        <DragHandle />
        {IconComponent && <IconComponent />}
      </ListItemIcon>
      <ListItemText primary={field.name} />
    </ListItem>
  );
};

const StringEditColumn = (props) => <EditColumn {...props} />;
const NumberEditColumn = (props) => <EditColumn {...props} />;
const DateEditColumn = (props) => <EditColumn {...props} />;
const StatusEditColumn = (props) => <EditColumn {...props} />;
const TimeReportEditColumn = (props) => <EditColumn {...props} />;

export { StringEditColumn, NumberEditColumn, DateEditColumn, StatusEditColumn, TimeReportEditColumn };
